import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class IconText extends Vue {
  @Prop() private label!: string;
  @Prop() private icon!: string;
}
